export default "__VITE_ASSET__P9A7dzYn__"